module.exports = __webpack_public_path__ + "static/media/CHANGELOG.90ed9ab9.md";